// This component is a customized version of SidebarSearchModal from @backstage/plugin-search.
// https://github.com/backstage/backstage/blob/d91c1f2a12757debd8f7c110a4dd4a97cc7f370e/plugins/search/src/components/SidebarSearchModal/SidebarSearchModal.tsx

import React from "react";
import SearchIcon from '@material-ui/icons/Search';
import { SidebarItem } from '@backstage/core-components';
import { IconComponent } from '@backstage/core-plugin-api';
import {
  SearchModalProps,
  SearchModalProvider,
  useSearchModal,
} from '@backstage/plugin-search';
import { CustomSearchModal } from '../../plugin';
import { KeyboardShortcutHandler } from '../KeyboardShortcutHandler';

/**
 * Props for {@link SidebarSearchModal}.
 *
 * @public
 */
export type SidebarSearchModalProps = Pick<
  SearchModalProps,
  'children' | 'resultItemComponents'
> & {
  icon?: IconComponent;
};

const SidebarSearchModalContent = (props: SidebarSearchModalProps) => {
  const { state, toggleModal } = useSearchModal();
  const Icon = props.icon ? props.icon : SearchIcon;

  return (
    <>
      <SidebarItem
        className="search-icon"
        icon={Icon}
        text="Search"
        onClick={toggleModal}
      />
      <CustomSearchModal
        {...state}
        toggleModal={toggleModal}
        resultItemComponents={props.resultItemComponents}
        children={props.children}
      />
    </>
  );
};

export const CustomSidebarSearchModal = (props: SidebarSearchModalProps) => {
  return (
    <SearchModalProvider>
      <KeyboardShortcutHandler />
      <SidebarSearchModalContent {...props} />
    </SearchModalProvider>
  );
};